import React, {useState} from "react";
import MultiDropDownWrapper from "./CustomMultiDropDown/multiDropDownWrapper";
import {useDispatch} from "react-redux";
import {COMPANY_ID_LIST} from "../../Reducers/companyIdListReducer";
import {constructCompanyIdList} from "../../Factory/factory";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";

const MultiDropDownComponent = ({allText = "Aggregate for all stores"}) => {
    const { data: enterpriseAccounts } = useFetchCompanyInfosQuery();
    const dispatch = useDispatch();
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);

    const updateSelectedList = (selectedCompanyIdArr) => {
        setSelectedCompanyList(selectedCompanyIdArr);
        dispatch({
            type: COMPANY_ID_LIST,
            payload: constructCompanyIdList(selectedCompanyIdArr)
        })
    }

    if (!enterpriseAccounts) return <></>;

    return (
        <div className='multi-dropdown'>
            <MultiDropDownWrapper listArr={enterpriseAccounts.getCompanyIdNamePair()}
                                  onChange={updateSelectedList} selectedCompanyList={selectedCompanyList} 
                                  allText={allText}/>
        </div>
    )
}

export default MultiDropDownComponent;
